import { render, staticRenderFns } from "./NModalLink.vue?vue&type=template&id=39c0e82c"
import script from "./NModalLink.vue?vue&type=script&lang=js"
export * from "./NModalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports